module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Router1-1ea7ac6805fb641e24b7abd2ebbdb7c2.svg";